<ng-container *ngIf="linkContainers$ | async as linkContainers">
  <div class="row">
    <div class="col-6 col-lg-4" *ngFor="let linkContainer of linkContainers | sortLinksContainer">
      <h4>{{ linkContainer.label }}</h4>
      <ng-container *ngFor="let link of linkContainer.links">
        <cx-generic-link class="py-1 d-block" [url]="link?.url" [target]="link?.target">{{ link?.label }}</cx-generic-link>
      </ng-container>
    </div>
  </div>
</ng-container>
